import React, { Key, useEffect, useRef } from 'react';

import kemtapi from 'skeleton-api';
import { Keypoints } from  'skeleton-api';
export type PointName = string;

// Define the connections between points
  const connections = [
    //["top_of_the_head", "nose"],
    ["nose", "chin"],
    ["chin", "neck"],
    ["neck", "left_shoulder"],
    ["neck", "right_shoulder"],
    ["left_shoulder", "left_elbow"],
    ["left_elbow", "left_wrist"],
    ["right_shoulder", "right_elbow"],
    ["right_elbow", "right_wrist"],
    ["neck", "front_1"],
    ["front_1", "front_2"],
    ["front_2", "front_3"],
    ["front_3", "front_4"],
    ["front_4", "front_5"],
    ["left_hip", "front_5"],
    ["right_hip", "front_5"],
    ["left_hip", "left_knee"],
    ["left_knee", "left_ankle"],
    ["right_hip", "right_knee"],
    ["right_knee", "right_ankle"],
  ];

  export const bones: [string, string][] = [
  ["nose", "chin"],
  ["chin", "neck"],
  ["neck", "left_shoulder"],
  ["neck", "right_shoulder"],
  ["left_shoulder", "left_elbow"],
  ["left_elbow", "left_wrist"],
  ["right_shoulder", "right_elbow"],
  ["right_elbow", "right_wrist"],
  ["neck", "front_1"],
  ["front_1", "front_2"],
  ["front_2", "front_3"],
  ["front_3", "front_4"],
  ["front_4", "front_5"],
  ["left_hip", "front_5"],
  ["right_hip", "front_5"],
  ["left_hip", "left_knee"],
  ["left_knee", "left_ankle"],
  ["right_hip", "right_knee"],
  ["right_knee", "right_ankle"],
];

const EXCLUDED_HAND_LEG_POINTS = new Set([
  // Wrists
  "left_wrist", "right_wrist",

  // Hands - fingers
  "left_thumb1", "left_thumb2", "left_thumb3", "left_thumb4",
  "left_forefinger1", "left_forefinger2", "left_forefinger3", "left_forefinger4",
  "left_middle_finger1", "left_middle_finger2", "left_middle_finger3", "left_middle_finger4",
  "left_ring_finger1", "left_ring_finger2", "left_ring_finger3", "left_ring_finger4",
  "left_pinky_finger1", "left_pinky_finger2", "left_pinky_finger3", "left_pinky_finger4",
  "left_finger", "left_thumb",

  "right_thumb1", "right_thumb2", "right_thumb3", "right_thumb4",
  "right_forefinger1", "right_forefinger2", "right_forefinger3", "right_forefinger4",
  "right_middle_finger1", "right_middle_finger2", "right_middle_finger3", "right_middle_finger4",
  "right_ring_finger1", "right_ring_finger2", "right_ring_finger3", "right_ring_finger4",
  "right_pinky_finger1", "right_pinky_finger2", "right_pinky_finger3", "right_pinky_finger4",
  "right_finger", "right_thumb",

  // Legs
  "left_knee", "right_knee",
  "left_ankle", "right_ankle",
  "left_bigtoe", "right_bigtoe",
  "left_smalltoe", "right_smalltoe",
  "left_heel", "right_heel",
  "LAI", "RAI", "LAF", "RAF", "LAE", "RAE", "LAB", "RAB", "LKI", "RKI", "LKF", "RKF", "LKE", "RKE"
]);

  export const drawPoints = (
    context: CanvasRenderingContext2D,
    frame: Keypoints|null,
    
  ) => {
    if (!frame) return  ;
    
    context.fillStyle = '#006633'; // Set point color
    
    for (let key of frame.points()) {
      if (EXCLUDED_HAND_LEG_POINTS.has(key)) {
        continue; // Skip drawing this point
    }
      const point = frame.get(key);
      if (!point) continue;
      
      if (point) {
        if (point.x >= 0 && point.y >= 0) {
          context.beginPath();
          context.arc(point.x, point.y, 5, 0, 2 * Math.PI); // Draw a circle for each point
          context.fill();
        }
      }
    }
  };
  




  // export const drawConnections = (
  //   context: CanvasRenderingContext2D,
  //   frame: Keypoints|null
  // ) => {
  //   if (!frame) return;
  //   // Draw connections
  //   context.strokeStyle = '#00FF00'; // Set line color
  //   context.lineWidth = 7; // Set line width
  //   for (const [start, end] of connections) {
  //     const startPoint = frame.get(start);
  //     const endPoint = frame.get(end);
      
  //     if (
  //       startPoint &&
  //       endPoint &&
  //       startPoint.x >= 0 &&
  //       startPoint.y >= 0 &&
  //       endPoint.x >= 0 &&
  //       endPoint.y >= 0
  //     ) {
  //       context.beginPath();
  //       context.moveTo(startPoint.x, startPoint.y); // Move to the starting point
  //       context.lineTo(endPoint.x, endPoint.y); // Draw a line to the endpoint
  //       context.stroke(); // Render the line
  //     }
  //   }
  // };
  
export const drawBone = (
  context: CanvasRenderingContext2D,
  kp: Keypoints,
  bone: [PointName, PointName, boolean?],
  color: string,
  skeletonType: 'DotsAndLines' | 'FilledBones' = 'FilledBones',
  fillBones: boolean = true
) => {
  const joint1 = kp.get(bone[0]);
  const joint2 = kp.get(bone[1]);
  const inverse = Boolean(bone[2]);

  if (!joint1 || !joint2 || joint1.x < 0 || joint2.x < 0) return;

  const xLen = joint2.x - joint1.x;
  const yLen = joint2.y - joint1.y;
  const h = skeletonType === 'DotsAndLines' ? 0 : 2;
  const hlen = h + Math.sqrt(xLen * xLen + yLen * yLen) / 20;
  const ratio = skeletonType === 'DotsAndLines' ? 1 : 0.85;

  const middle = inverse
    ? {
        x: joint1.x + xLen * ratio,
        y: joint1.y + yLen * ratio,
      }
    : {
        x: joint2.x - xLen * ratio,
        y: joint2.y - yLen * ratio,
      };

  const angle = Math.atan2(joint1.x - joint2.x, joint1.y - joint2.y) - Math.PI / 2;

  if (skeletonType === 'DotsAndLines') {
    context.beginPath();
    context.moveTo(joint1.x, joint1.y);
    context.lineTo(joint2.x, joint2.y);
    context.strokeStyle = color;
    context.lineWidth = 2;
    context.stroke();
    return;
  }

  context.beginPath();
  context.moveTo(joint1.x, joint1.y);
  context.lineTo(middle.x + hlen * Math.sin(angle), middle.y + hlen * Math.cos(angle));
  context.lineTo(joint2.x, joint2.y);
  context.lineTo(middle.x - hlen * Math.sin(angle), middle.y - hlen * Math.cos(angle));
  context.closePath();

  context.lineWidth = 2;
  context.setLineDash([]);
  context.lineCap = 'round';
  context.strokeStyle = color;

  if (fillBones) {
    context.fillStyle = color;
    context.fill();
  }

  context.stroke();
};

export const drawJoint = (
  context: CanvasRenderingContext2D,
  kp: Keypoints,
  name: PointName,
  radius: number = 5,
  color: string = '#ffffff'
) => {
  const joint = kp.get(name);
  if (!joint || joint.x < 0 || joint.y < 0) return;

  context.beginPath();
  context.arc(joint.x, joint.y, radius, 0, 2 * Math.PI);
  context.fillStyle = color;
  context.fill();
};




  export const drawFrogHead = (
    context: CanvasRenderingContext2D,
    frame: Keypoints|null,
    frogImage: HTMLImageElement | null
  ) => {
    if (!frame || !frogImage) return;
    
    const nose = frame.get("nose");
    const topOfTheHead = frame.get("top_of_the_head");
    //const image = frogImageRef.current;
    
    if (!nose || !topOfTheHead) return;
     
      
      const dist = Math.sqrt((nose.x-topOfTheHead.x) **2 + (nose.y-topOfTheHead.y) **2);
      
      // Calculate the angle between "nose" and "top_of_the_head"
      const angle = Math.atan2(topOfTheHead.y - nose.y, topOfTheHead.x - nose.x);
      //console.log( "frame " + frameIndex + " angle " + angle);
      
      // Set image size
      const imageWidth = dist*2;
      const imageHeight = dist*2;
      
      
      // Rotate and draw the image
      context.save(); // Save the current canvas state
      context.translate(nose.x, nose.y); // Move the canvas origin to the "nose" position
      context.rotate(angle + Math.PI / 2); // Rotate the canvas (add 90 degrees to align the image vertically)
      context.drawImage(
        frogImage,
        -imageWidth / 2, // Center the image
        -imageHeight / 2,
        imageWidth,
        imageHeight
      );
      context.restore(); // Restore the canvas state
    };
  
    export const drawHandsAndLegs = (
      context: CanvasRenderingContext2D,
      frame: Keypoints,
      handImage: HTMLImageElement | null
    ) => {
      const handConnections: [string, string][] = [
        ["left_wrist", "left_middle_finger1"],
        ["right_wrist", "right_middle_finger1"],
        ["left_ankle", "left_bigtoe"],
        ["right_ankle", "right_bigtoe"],
      ];
    
      
      if (!handImage) return;
    
      for (const [start, end] of handConnections) {
        const startPoint = frame.get(start);
        const endPoint = frame.get(end);
    
        if (!startPoint || !endPoint) continue;
    
        // Dynamically compute the image size based on limb length
        const dx = endPoint.x - startPoint.x;
        const dy = endPoint.y - startPoint.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        const imageSize = distance * 1.5; 
    
        const angle = Math.atan2(dy, dx);
    
        context.save();
        context.translate(startPoint.x, startPoint.y);
        context.rotate(angle + Math.PI / 2);
    
        const adjustedX = -imageSize / 2;
        const adjustedY = -imageSize;
    
        context.drawImage(handImage, adjustedX, adjustedY, imageSize, imageSize);
        context.restore();
      }
    };
